/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, August 21st 2023, 12:55:21 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Grid from "@mui/material/Grid";
import { IntegrationCredentialStore } from "lib/schemas";
import { CredentialStoreCard } from "integrations/components";
import { useIntegrationsAPI } from "integrations/services/IntegrationsAPI";
import { OSActionButton } from "ui-widgets";

interface ChooseExistingCredentialsProps {
  onSelectCredentialStore: (credentialStore: IntegrationCredentialStore) => void;
}

export const ChooseExistingCredentials = ({ onSelectCredentialStore }: ChooseExistingCredentialsProps) => {
  const [credentialStores, setCredentialStores] = React.useState<IntegrationCredentialStore[]>(null);
  const { useAPIListCredentialStores } = useIntegrationsAPI();
  const { fetchCredentialStores } = useAPIListCredentialStores();

  React.useEffect(() => {
    fetchCredentialStores(setCredentialStores);
  }, [fetchCredentialStores]);

  return (
    <Grid container spacing={4}>
      {credentialStores?.map((credentialStore) => (
        <Grid item xs={12} md={6}>
          <CredentialStoreCard
            storeName={credentialStore.name}
            actions={
              <OSActionButton
                variant="outlined"
                size="large"
                onClick={(e) => {
                  onSelectCredentialStore(credentialStore);
                }}
                actionStyle="custom"
                customIcon={<AddCircleIcon />}
              >
                Assign Credential
              </OSActionButton>
            }
          />
        </Grid>
      ))}
    </Grid>
  );
};
